import React from 'react';
import { brandLogos } from '../mockData';

const BrandSlider = () => {
  // Double the logos for seamless loop
  const duplicatedLogos = [...brandLogos, ...brandLogos, ...brandLogos];

  return (
    <section className="py-16 bg-white border-t border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2E3C5B] mb-4">
            We Service All Major Brands
          </h2>
          <p className="text-lg text-gray-600">
            Authorized service center for leading laptop manufacturers
          </p>
        </div>

        {/* Animated Slider */}
        <div className="relative overflow-hidden">
          <div className="flex animate-scroll gap-16 items-center">
            {duplicatedLogos.map((brand, index) => (
              <div
                key={`${brand.name}-${index}`}
                className="flex-shrink-0 w-32 h-20 flex items-center justify-center grayscale hover:grayscale-0 transition-all duration-300 cursor-pointer group"
              >
                <img
                  src={brand.url}
                  alt={brand.name}
                  className="max-w-full max-h-full object-contain group-hover:scale-110 transition-transform duration-300"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.parentElement.innerHTML = `<div class="text-2xl font-bold text-gray-400">${brand.name}</div>`;
                  }}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Trust Badge */}
        <div className="mt-12 text-center">
          <p className="text-gray-600 font-medium">
            Trusted by <span className="text-[#E94B3C] font-bold">500,000+</span> customers across India
          </p>
        </div>
      </div>

      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(calc(-100% / 3));
          }
        }

        .animate-scroll {
          animation: scroll 30s linear infinite;
        }

        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default BrandSlider;
